
import { Component, Vue, Watch, Prop, ProvideReactive, InjectReactive } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action, State } from "vuex-class"

import { CaseDetails, TemplateDetails, User, CaseField } from "@/types"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import CaseDetailsHeader from "@/components/CaseDetails/CaseDetailsHeader.vue"
import CaseSideBar from "@/components/CaseDetails/CaseSideBar.vue"
import CaseFields from "@/components/CaseDetails/CaseFields.vue"
import CaseFiles from "@/components/CaseDetails/CaseFiles.vue"
import KeyEntries from "@/components/CaseDetails/KeyEntries.vue"
import MapDisplay from "@/components/Controls/Map.vue"
import CaseActions from "@/components/CaseDetails/CaseActions.vue"
import CCEventModal from "@/components/CaseDetails/CCEvent/CCEventModal.vue"
import { LayoutLocations } from "@/types/templateLayout"
import CaseFile from "@/types/caseFile"
import { CaseEvents } from "@/types/originatingEvents"

import api from "@/services/api"
import { IntegrationOutOption } from "@/types/integration"
import FileService from "@/services/file-service"
import { TenantSettingKeys } from "@/types/tenantSetting"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"case-header": CaseDetailsHeader,
		"case-fields": CaseFields,
		"case-actions": CaseActions,
		"map-display": MapDisplay,
		"case-files": CaseFiles,
		"key-entries": KeyEntries,
		"case-side-bar": CaseSideBar,
		"cc-event-modal": CCEventModal
	}
})
export default class Desktop extends Vue {
	@InjectReactive("fileService") fileService!: FileService

	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;
	@State tenantSettings!: { [key: string]: boolean } | null;

	@Prop()
	public currentCase!: CaseDetails | null

	@Prop()
	public me!: User

	@Prop({ default: false })
	titleTemplateEnabled!: boolean

	@Prop({ default: false })
	canEditCurrentCase!: boolean

	@Prop({ default: true })
	canCreateComments!: boolean

	@Prop({ default: false })
	editAfterClosePermissions!: boolean

	@Prop()
	template!: TemplateDetails

	@Prop({ default: false })
	preventTemplateChange!: boolean

	@Prop({ default: false })
	hasMap!: boolean

	@Prop({ default: true })
	showAttachments!: boolean

	@Prop({ default: true })
	showTimeline!: boolean

	@Prop({ default: true })
	canUploadFiles!: boolean

	@Prop({ default: true })
	showTitle!: boolean

	@Prop({ default: () => [] })
	caseFiles!: CaseFile[]

	@Prop({ default: () => null })
	public caseEvents!: CaseEvents

	@Prop({ default: () => [] })
	caseIntegrationLinks!: IntegrationOutOption[]

	private layoutLocations = LayoutLocations;

	templateIdChanged (templateId: string) {
		this.$emit("templateIdChanged", templateId)
	}

	caseChanged () {
		if (this.currentCase && this.currentCase.id) {
			api.saveCase(this.currentCase)
		}
	}

	public makeClosedChanges () {
		this.$emit("makeClosedChanges")
	}

	close () {
		this.$emit("close")
	}

	integrationPush (outputOption: IntegrationOutOption) {
		this.$emit("integrationPush", outputOption)
	}

	private get displayAreaSelectInHeader (): boolean {
		return (this.tenantSettings && this.tenantSettings[TenantSettingKeys.DisplayAreaSelectInHeader]) ?? false
	}
}
